export default __webpack_public_path__ + "static/media/1055.dd96ee5a.png";